<p-toast
    [key]="key"
    (onClose)="onClose.emit($event)"
></p-toast>
